import { isEqual, isString } from 'lodash-es';
import isIsoDate from 'is-iso-date';
import { createSelectorCreator, defaultMemoize } from 'reselect';

export const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

export function toISODateString(a?: unknown): string | null {
    if (!isString(a)) return null;
    if (isIsoDate(a)) return a;

    const withTime = `${a}T00:00:00.000Z`;
    if (isIsoDate(withTime)) return withTime;

    return null;
}

export function isUrl(url: string) {
    try {
        const _ = new URL(url);
        return true;
    } catch {
        return false;
    }
}
